import { NgModule } from "@angular/core";
import { IonicPageModule } from "ionic-angular";
import { DtbSharePage } from "./dtb-share";

@NgModule({
  declarations: [DtbSharePage],
  imports: [IonicPageModule.forChild(DtbSharePage)],
})
export class DtbSharePageModule {}



// WEBPACK FOOTER //
// ./src/pages/dtb-share/dtb-share.module.ts